(function () {
  if (window.__mpgProductBundlesOptionsInit) return;
  window.__mpgProductBundlesOptionsInit = true;

  var ROOT_SELECTOR = '[data-mpg-bundles]';
  var LIST_SELECTOR = '.mpgBundles__list';
  var CARD_SELECTOR = '[data-mpg-bundle-card]';
  var TOGGLE_SELECTOR = '[data-mpg-bundles-toggle]';
  var DETAIL_SELECTOR = '[data-mpg-bundle-detail]';
  var COLLAPSE_AFTER = 3;

  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function closest(el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getCards(listElement) {
    return toArray(listElement.children).filter(function (element) {
      return element.matches && element.matches(CARD_SELECTOR);
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.money_format) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return String(cents);
  }

  function normalizeTag(value) {
    return String(value == null ? '' : value)
      .replace(/\u00a0/g, ' ')
      .trim();
  }

  function parseVariantsJson(text) {
    try {
      var data = JSON.parse(text || '[]');
      if (Array.isArray(data)) return data;
    } catch (error) {
      /* ignore */
    }
    return null;
  }

  function readVariantsFromDom(scope) {
    var root = scope || document;
    var mpgScript = null;

    // data-mpg-general-variants 在 .mpgGeneral 外层（shopify-section 内兄弟节点），需向上/全局查找
    if (root.querySelector) {
      mpgScript = root.querySelector('[data-mpg-general-variants]');
    }
    if (!mpgScript && root.nodeType === 1) {
      var shopifySection = closest(root, '.shopify-section');
      if (shopifySection) {
        mpgScript = shopifySection.querySelector('[data-mpg-general-variants]');
      }
    }
    if (!mpgScript) {
      mpgScript = document.querySelector('[data-mpg-general-variants]');
    }

    if (mpgScript) {
      var fromMpg = parseVariantsJson(mpgScript.textContent);
      if (fromMpg) return fromMpg;
    }

    var picker = root.querySelector ? root.querySelector('variant-radios, variant-selects') : null;
    if (picker) {
      // variant-radios 内可能有多个 JSON（如 sale-categories 对象 + variants 数组），只取变体数组
      var scripts = toArray(picker.querySelectorAll('[type="application/json"]'));
      for (var i = 0; i < scripts.length; i += 1) {
        if (scripts[i].hasAttribute('data-mpg-variant-sale-categories')) continue;
        var fromPicker = parseVariantsJson(scripts[i].textContent);
        if (fromPicker && fromPicker.length && fromPicker[0] && fromPicker[0].id != null) {
          return fromPicker;
        }
      }
    }

    return [];
  }

  function getProductSection(scope) {
    var root = scope || document;
    return (
      closest(root, '[data-section-type="product"]') ||
      closest(root, '.mpgGeneral') ||
      closest(root, '.product-details') ||
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.mpgGeneral') ||
      document.querySelector('.product-details')
    );
  }

  function getSelectedVariantId(section) {
    if (!section) return null;

    var selectors = [
      'form[data-type="add-to-cart-form"] input[name="id"]',
      'form[action*="/cart/add"] input[name="id"]',
      'product-form input[name="id"]',
      'input[name="id"][value]'
    ];

    for (var s = 0; s < selectors.length; s += 1) {
      var inputs = toArray(section.querySelectorAll(selectors[s]));
      for (var i = 0; i < inputs.length; i += 1) {
        var asNumber = Number(inputs[i].value);
        if (Number.isFinite(asNumber) && asNumber > 0) return asNumber;
      }
    }

    return null;
  }

  function matchVariantByOptions(section, variants) {
    if (!section || !Array.isArray(variants) || !variants.length) return null;

    var radiosRoot =
      section.querySelector('variant-radios.mpgGeneral__variantRadios') ||
      section.querySelector('variant-radios, variant-selects');
    if (!radiosRoot) return null;

    var optionValues = toArray(radiosRoot.querySelectorAll('.mpgGeneral__optionField')).map(function (fieldset) {
      var checked = fieldset.querySelector('.mpgGeneral__optionInput:checked');
      return checked ? checked.value : null;
    });

    // 兼容标准 Dawn 系 option 选择器
    if (!optionValues.length) {
      optionValues = toArray(radiosRoot.querySelectorAll('fieldset')).map(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    if (!optionValues.length) return null;

    return (
      variants.find(function (variant) {
        return [variant.option1 || null, variant.option2 || null, variant.option3 || null].every(function (value, index) {
          return optionValues[index] == null || optionValues[index] === value;
        });
      }) || null
    );
  }

  function getMatchedVariant(section, variants) {
    if (!section || !Array.isArray(variants) || !variants.length) return null;

    var byOptions = matchVariantByOptions(section, variants);
    if (byOptions) return byOptions;

    var picker = section.querySelector('variant-radios, variant-selects');
    if (picker && picker.currentVariant) {
      return picker.currentVariant;
    }

    var selectedId = getSelectedVariantId(section);
    if (selectedId == null) return null;

    return findVariantById(variants, selectedId);
  }

  /**
   * 跨店铺通用：优先用加购表单的 variant id（与 sale-categories / variants JSON 位置无关），
   * 再用 bundles 内嵌 current-variants 或页面 variants JSON 解析出完整对象。
   */
  function getSelectedVariant(scope) {
    var section = getProductSection(scope);
    if (!section) return null;

    var selectedId = getSelectedVariantId(section);
    var bundleVariants = readCurrentProductVariants(scope);
    var pageVariants = readVariantsFromDom(section);

    // 1) 表单 id 已更新：直接按 id 解析（最稳，兼容有/无 sale-categories）
    if (selectedId != null) {
      return (
        findVariantById(bundleVariants, selectedId) ||
        findVariantById(pageVariants, selectedId) ||
        { id: selectedId }
      );
    }

    // 2) 表单尚未同步时：按 option 选择匹配
    return (
      getMatchedVariant(section, pageVariants) ||
      getMatchedVariant(section, bundleVariants) ||
      null
    );
  }

  function readCardVariants(card) {
    if (!card) return [];
    if (card.__mpgBundleVariants) return card.__mpgBundleVariants;

    var script = card.querySelector('[data-mpg-bundle-variants]');
    if (!script) {
      card.__mpgBundleVariants = [];
      return card.__mpgBundleVariants;
    }

    try {
      card.__mpgBundleVariants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      card.__mpgBundleVariants = [];
    }

    return card.__mpgBundleVariants;
  }

  function findVariantById(variants, variantId) {
    if (!variants || !variants.length || variantId == null) return null;

    return (
      variants.find(function (variant) {
        return Number(variant.id) === Number(variantId);
      }) || null
    );
  }

  function findVariantByTag(variants, variantTag) {
    var tag = normalizeTag(variantTag);
    if (!variants || !variants.length || !tag) return null;

    return (
      variants.find(function (variant) {
        return normalizeTag(variant.variant_tag) === tag;
      }) || null
    );
  }

  function readCurrentProductVariants(scope) {
    var root =
      (scope && closest(scope, ROOT_SELECTOR)) ||
      document.querySelector(ROOT_SELECTOR);
    if (!root) return [];

    if (root.__mpgBundlesCurrentVariants) return root.__mpgBundlesCurrentVariants;

    var script = root.querySelector('[data-mpg-bundles-current-variants]');
    if (!script) {
      root.__mpgBundlesCurrentVariants = [];
      return root.__mpgBundlesCurrentVariants;
    }

    try {
      root.__mpgBundlesCurrentVariants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      root.__mpgBundlesCurrentVariants = [];
    }

    return root.__mpgBundlesCurrentVariants;
  }

  function getSelectedVariantTag(selectedVariant, scope) {
    if (!selectedVariant) return '';

    var selectedId = selectedVariant.id;

    // 优先从当前页产品自己的 variants+tag 数据取（不依赖列表里是否有当前产品卡）
    var currentProductMatch = findVariantById(readCurrentProductVariants(scope), selectedId);
    if (currentProductMatch && normalizeTag(currentProductMatch.variant_tag)) {
      return normalizeTag(currentProductMatch.variant_tag);
    }

    var currentCard = document.querySelector('[data-mpg-bundle-current]');
    if (currentCard) {
      var currentMatch = findVariantById(readCardVariants(currentCard), selectedId);
      if (currentMatch && normalizeTag(currentMatch.variant_tag)) {
        return normalizeTag(currentMatch.variant_tag);
      }
    }

    var cards = toArray(document.querySelectorAll(CARD_SELECTOR));
    for (var i = 0; i < cards.length; i += 1) {
      var match = findVariantById(readCardVariants(cards[i]), selectedId);
      if (match && normalizeTag(match.variant_tag)) {
        return normalizeTag(match.variant_tag);
      }
    }

    return normalizeTag(selectedVariant.variant_tag);
  }

  function buildVariantUrl(baseUrl, variantId) {
    if (!baseUrl) return '';

    var cleanedBase = String(baseUrl).split('?')[0].split('#')[0];
    if (!cleanedBase) return baseUrl;

    if (!variantId) return cleanedBase;

    try {
      var url = new URL(cleanedBase, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return cleanedBase + '?variant=' + encodeURIComponent(String(variantId));
    }
  }

  function getCardBaseUrl(card) {
    if (!card) return '';
    return card.getAttribute('data-bundle-base-url') || card.getAttribute('data-bundle-url') || '';
  }

  function resolveCardMatchedVariant(card, scope) {
    if (!card) return null;

    var cardVariants = readCardVariants(card);
    if (!cardVariants.length) return null;

    var selectedVariant = getSelectedVariant(scope || card);
    if (!selectedVariant) return null;

    if (card.hasAttribute('data-mpg-bundle-current')) {
      var byId = findVariantById(cardVariants, selectedVariant.id);
      if (byId) return byId;
    }

    var selectedTag = getSelectedVariantTag(selectedVariant, scope || card);
    if (!selectedTag) return null;

    return findVariantByTag(cardVariants, selectedTag);
  }

  function applyVariantPriceToCard(card, variant) {
    if (!card || !variant) return false;

    var price = Number(variant.price);
    if (!Number.isFinite(price)) return false;

    var compareAt = variant.compare_at_price != null ? Number(variant.compare_at_price) : null;
    var hasDiscount = compareAt != null && Number.isFinite(compareAt) && compareAt > price;

    var priceElement = card.querySelector('[data-mpg-bundle-price]');
    var compareElement = card.querySelector('[data-mpg-bundle-compare]');
    var badgeElement = card.querySelector('.mpgBundles__saveBadge');
    var pricesWrap = card.querySelector('.mpgBundles__prices');
    var baseUrl = getCardBaseUrl(card);

    if (priceElement) {
      priceElement.textContent = formatMoney(price);
    }

    if (variant.id) {
      card.setAttribute('data-matched-variant-id', String(variant.id));
      card.setAttribute('data-bundle-url', buildVariantUrl(baseUrl, variant.id));
    }

    if (hasDiscount) {
      if (!compareElement && pricesWrap) {
        compareElement = document.createElement('span');
        compareElement.className = 'mpgBundles__comparePrice';
        compareElement.setAttribute('data-mpg-bundle-compare', '');
        compareElement.innerHTML = '<s></s>';
        pricesWrap.appendChild(compareElement);
      }

      if (compareElement) {
        var compareText = compareElement.querySelector('s') || compareElement;
        compareText.textContent = formatMoney(compareAt);
        compareElement.hidden = false;
      }

      if (!badgeElement) {
        badgeElement = document.createElement('span');
        badgeElement.className = 'mpgBundles__saveBadge';
        card.insertBefore(badgeElement, card.firstChild);
      }

      badgeElement.textContent = 'SAVE ' + formatMoney(compareAt - price);
      badgeElement.hidden = false;
      return true;
    }

    if (compareElement) compareElement.remove();
    if (badgeElement) badgeElement.remove();
    return true;
  }

  function updateAllBundleCardPrices(scope) {
    var selectedVariant = getSelectedVariant(scope);
    if (!selectedVariant) return;

    var selectedTag = getSelectedVariantTag(selectedVariant, scope);
    if (!selectedTag) return;

    toArray(document.querySelectorAll(CARD_SELECTOR)).forEach(function (card) {
      var cardVariants = readCardVariants(card);
      if (!cardVariants.length) return;

      var matchedVariant = null;

      if (card.hasAttribute('data-mpg-bundle-current')) {
        matchedVariant =
          findVariantById(cardVariants, selectedVariant.id) || findVariantByTag(cardVariants, selectedTag);
      } else {
        matchedVariant = findVariantByTag(cardVariants, selectedTag);
      }

      if (!matchedVariant) return;
      applyVariantPriceToCard(card, matchedVariant);
    });
  }

  var bundlePriceUpdateScheduled = false;

  function scheduleBundleCardPriceUpdate(scope) {
    if (bundlePriceUpdateScheduled) return;
    bundlePriceUpdateScheduled = true;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        bundlePriceUpdateScheduled = false;
        updateAllBundleCardPrices(scope);
      });
    });
  }

  function shouldReactToVariantChange(target) {
    if (!target) return false;

    if (target.name === 'id' && closest(target, 'form[data-type="add-to-cart-form"]')) {
      return true;
    }

    if (target.closest('variant-radios') || target.closest('variant-selects')) {
      return true;
    }

    if (target.classList && target.classList.contains('mpgGeneral__optionInput')) {
      return true;
    }

    return false;
  }

  function updateToggleState(toggle, isExpanded) {
    if (!toggle) return;

    var expandedValue = isExpanded ? 'true' : 'false';
    if (toggle.getAttribute('aria-expanded') !== expandedValue) {
      toggle.setAttribute('aria-expanded', expandedValue);
    }

    var textElement = toggle.querySelector('.mpgBundlesToggle__text');
    var nextText = isExpanded ? 'View Less' : 'View All';
    if (textElement && textElement.textContent !== nextText) {
      textElement.textContent = nextText;
    }
  }

  function ensureToggle(rootElement, listElement) {
    var toggle = rootElement.querySelector(TOGGLE_SELECTOR);
    if (toggle) return toggle;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mpgBundlesToggle';
    toggle.setAttribute('data-mpg-bundles-toggle', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = `
      <span class="mpgBundlesToggle__text">View All</span>
      <span class="mpgBundlesToggle__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M22.6667 13.3334L16 20L9.33335 13.3334" stroke="#0BB3FB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    `;

    toggle.addEventListener('click', function () {
      var isExpanded = listElement.classList.contains('is-mpg-bundles-expanded');
      listElement.classList.toggle('is-mpg-bundles-expanded', !isExpanded);
      listElement.classList.toggle('is-mpg-bundles-collapsed', isExpanded);
      updateToggleState(toggle, !isExpanded);
    });

    listElement.insertAdjacentElement('afterend', toggle);
    return toggle;
  }

  function updateRoot(rootElement) {
    if (!rootElement) return;

    var listElement = rootElement.querySelector(LIST_SELECTOR);
    if (!listElement) return;

    var cards = getCards(listElement);
    var toggle = rootElement.querySelector(TOGGLE_SELECTOR);

    if (cards.length <= COLLAPSE_AFTER) {
      listElement.classList.remove(
        'is-mpg-bundles-collapsible',
        'is-mpg-bundles-collapsed',
        'is-mpg-bundles-expanded'
      );
      if (toggle) toggle.remove();
      return;
    }

    listElement.classList.add('is-mpg-bundles-collapsible');

    if (!listElement.classList.contains('is-mpg-bundles-expanded')) {
      listElement.classList.add('is-mpg-bundles-collapsed');
    }

    toggle = ensureToggle(rootElement, listElement);
    updateToggleState(toggle, listElement.classList.contains('is-mpg-bundles-expanded'));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var STOREFRONT_API_VERSION = '2025-01';
  var DETAIL_ICON = `
    <span class="mpgBundles__detailBtnIcon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 6L8 10L12 6" stroke="#0bb3fb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  function getStorefrontEndpoint() {
    var shop = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    return `https://${shop}/api/${STOREFRONT_API_VERSION}/graphql.json`;
  }

  function buildProductUrl(handle, variantGid) {
    if (!handle) return '';
    var rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (rootPath.slice(-1) !== '/') rootPath += '/';
    var url = `${rootPath}products/${encodeURIComponent(handle)}`;
    var variantId = variantGid ? String(variantGid).split('/').pop() : '';
    if (variantId) url += `?variant=${encodeURIComponent(variantId)}`;
    return url;
  }

  function fetchBundleComponents(token, variantIds) {
    var query = `
      query ($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            components(first: 30) {
              nodes {
                quantity
                productVariant {
                  id
                  image { url(transform: { maxWidth: 80 }) }
                  product {
                    handle
                    title
                    featuredImage { url(transform: { maxWidth: 80 }) }
                  }
                }
              }
            }
          }
        }
      }
    `;

    return fetch(getStorefrontEndpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({
        query: query,
        variables: {
          ids: variantIds.map(function (id) {
            return `gid://shopify/ProductVariant/${id}`;
          })
        }
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          console.warn('[mpgBundles] Storefront GraphQL errors', payload.errors);
        }
        if (!payload.data || !payload.data.nodes) return {};

        var map = {};
        payload.data.nodes.forEach(function (node) {
          if (!node || !node.id) return;
          map[String(node.id).split('/').pop()] = (node.components.nodes || [])
            .map(function (item) {
              var variant = item.productVariant || {};
              var product = variant.product || {};
              return {
                title: product.title || '',
                quantity: item.quantity,
                image:
                  (variant.image && variant.image.url) ||
                  (product.featuredImage && product.featuredImage.url) ||
                  '',
                url: buildProductUrl(product.handle, variant.id)
              };
            })
            .filter(function (item) {
              return item.title;
            });
        });
        return map;
      })
      .catch(function (error) {
        console.warn('[mpgBundles] Storefront request error', error);
        return {};
      });
  }

  function renderComponentItem(item) {
    var thumb = item.image
      ? `<img class="mpgBundles__componentImage" src="${escapeHtml(item.image)}" alt="" loading="lazy" width="40" height="40">`
      : '<span class="mpgBundles__componentPlaceholder"></span>';
    var qty =
      item.quantity != null && item.quantity !== ''
        ? `<span class="mpgBundles__componentQty">× ${escapeHtml(item.quantity)}</span>`
        : '';
    var body = `
      <span class="mpgBundles__componentThumb" aria-hidden="true">${thumb}</span>
      <span class="mpgBundles__componentMeta">
        <span class="mpgBundles__componentTitle">${escapeHtml(item.title)}</span>
        ${qty}
      </span>
    `;

    return `
      <li class="mpgBundles__component">
        ${
          item.url
            ? `<a class="mpgBundles__componentLink" href="${escapeHtml(item.url)}">${body}</a>`
            : body
        }
      </li>
    `;
  }

  function renderDetailSlot(card, components) {
    var slot = card.querySelector('[data-mpg-bundle-detail-slot]');
    if (!slot) return;

    if (!components || !components.length) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }

    var detailId = escapeHtml(slot.getAttribute('data-detail-id') || '');
    var listHtml = components.map(renderComponentItem).join('');

    slot.hidden = false;
    slot.innerHTML = `
      <button
        type="button"
        class="mpgBundles__detailBtn"
        data-mpg-bundle-detail
        aria-expanded="false"
        aria-controls="${detailId}"
      >
        Detail
        ${DETAIL_ICON}
      </button>
      <div
        id="${detailId}"
        class="mpgBundles__detailPanel"
        data-mpg-bundle-detail-panel
        hidden
      >
        <ul class="mpgBundles__components" role="list">${listHtml}</ul>
      </div>
    `;
  }

  function loadBundleDetails(root) {
    if (!root || root.__mpgBundleDetailsLoaded) return;

    var token = root.getAttribute('data-storefront-token');
    if (!token) return;

    var cards = toArray(root.querySelectorAll(CARD_SELECTOR));
    var variantIds = [];

    cards.forEach(function (card) {
      var id = card.getAttribute('data-bundle-first-variant-id');
      if (id && variantIds.indexOf(id) === -1) variantIds.push(id);
    });
    if (!variantIds.length) return;

    root.__mpgBundleDetailsLoaded = true;

    fetchBundleComponents(token, variantIds).then(function (map) {
      cards.forEach(function (card) {
        var id = card.getAttribute('data-bundle-first-variant-id');
        if (!id) return;
        renderDetailSlot(card, map[id] || []);
      });
    });
  }

  function initCollapse() {
    toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      updateRoot(root);
      loadBundleDetails(root);
    });
    scheduleBundleCardPriceUpdate();
  }

  function toggleBundleDetail(detailBtn) {
    var panel = detailBtn && detailBtn.parentElement &&
      detailBtn.parentElement.querySelector('[data-mpg-bundle-detail-panel]');
    if (!detailBtn || !panel) return;

    var willExpand = detailBtn.getAttribute('aria-expanded') !== 'true';
    detailBtn.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
    panel.hidden = !willExpand;
  }

  function onRootClick(event) {
    var root = closest(event.target, ROOT_SELECTOR);
    if (!root) return;

    if (closest(event.target, TOGGLE_SELECTOR)) return;
    if (closest(event.target, '.mpgBundles__componentLink')) return;

    var detailBtn = closest(event.target, DETAIL_SELECTOR);
    if (detailBtn && root.contains(detailBtn)) {
      event.preventDefault();
      toggleBundleDetail(detailBtn);
      return;
    }

    var selectBtn = closest(event.target, '[data-mpg-bundle-select]');
    if (!selectBtn || !root.contains(selectBtn)) return;

    var card = closest(selectBtn, CARD_SELECTOR);
    if (!card || card.hasAttribute('data-mpg-bundle-current')) return;

    var baseUrl = getCardBaseUrl(card);
    if (!baseUrl) return;

    var matchedVariant = resolveCardMatchedVariant(card, root);
    var matchedVariantId =
      (matchedVariant && matchedVariant.id) ||
      card.getAttribute('data-matched-variant-id') ||
      '';

    window.location.href = matchedVariantId
      ? buildVariantUrl(baseUrl, matchedVariantId)
      : buildVariantUrl(baseUrl);
  }

  document.addEventListener('click', onRootClick);

  document.addEventListener('change', function (event) {
    if (!shouldReactToVariantChange(event.target)) return;
    scheduleBundleCardPriceUpdate(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapse);
  } else {
    initCollapse();
  }

  document.addEventListener('shopify:section:load', initCollapse);
})();
